import { Navigate } from "react-router-dom";
import { useFeatures } from "../../hooks/useFeatures";
import LoadingState from "./LoadingState";

// Renders children only when this deployment has `feature` switched on;
// otherwise sends the visitor to the start page.
const FeatureGate = ({ feature, children }) => {
    const features = useFeatures();
    if (!features) return <LoadingState label="Loading…" />;
    return features[feature] ? children : <Navigate to="/" replace />;
};

export default FeatureGate;
